import axios, { AxiosResponse } from 'axios';

import { auth0Client } from '../auth0Client';

const referralsApi = {
  fetchReferrals: async (): Promise<AxiosResponse> => {
    const config = {
      headers: {
        Authorization: `Bearer ${await auth0Client.getTokenSilently()}`,
      },
    };

    return axios.get(
      `${process.env.REACT_APP_REFERRAL_API}/referrers/me/referrals`,
      config,
    );
  },
};

export default referralsApi;
